import React from "react";

import { getLocaleShortMonth, getLocaleIsRtl } from "../util/localisation";

import "./Months.css";

export const MONTH_CODES = [6, 2, 2, 5, 0, 3, 5, 1, 4, 6, 2, 4];

const Months = ({ small }) => (
  <div
    className={"Months" + (small ? " --small" : "")}
    dir={getLocaleIsRtl() ? "rtl" : null}
  >
    {[
      [0, 1, 2, 3, 4, 5],
      [6, 7, 8, 9, 10, 11],
    ].map((col, index) => (
      <div key={col}>
        {col.map((month) => (
          <div
            key={month}
            className={
              month === 1
                ? "-leap"
                : month === 3 || month === 5 || month === 8 || month === 10
                ? "-short"
                : ""
            }
          >
            <strong>{getLocaleShortMonth(month)}</strong>
            <em>
              {!small && month < 2 ? "*" : ""}
              {MONTH_CODES[month]}
            </em>
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default Months;
